interface NotificationDTO {
  showing: boolean;
  title: string;
  content: string[];
  icon: string;
  type: string;
  multiline: boolean;
  height: number;
}

interface NotificationState {
  notifications: NotificationDTO[];
}

const initialState : NotificationState = {
  notifications: [],
};

const getters = {
  notifications: (state: NotificationState): NotificationDTO[] => {
    return state.notifications;
  },
  notificationLength: (state: NotificationState): number => {
    return state.notifications.length;
  },
  notificationShowing: (state: NotificationState): NotificationDTO[] => {
    return state.notifications.filter(notification => notification.showing);
  },
  notificationHeight: (state: NotificationState): number[] => {
    let heights: number[] = [];
    state.notifications.map((notification) => {
      if (notification.showing) {
        heights = heights.concat(notification.height);
      }
    });
    return heights;
  }
};

const mutations = {
  setNotification(state: NotificationState, notification: NotificationDTO): void {
    if (state.notifications.length === 3) {
      state.notifications.splice(0, 1);
    }
    state.notifications = state.notifications.concat(notification);
  },
  updateNotificationShowing(state: NotificationState, index: number): void {
    const notificationShowing = getters.notificationShowing(state);
    notificationShowing[index].showing = false;
  },
  updateNotificationHeight(state: NotificationState, data: any): void {
    const notificationShowing = getters.notificationShowing(state);
    notificationShowing[data.index].height = data.height;
  },
};

const actions = {

};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};

export {
  NotificationDTO,
}
